var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 51,
    viewBox: "0 0 53 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_823_7682)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_823_7682)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 51,
    height: 49,
    rx: 21.6277,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9807 34.7652C9.05079 38.0343 7.43858 47.3683 8.13843 51.82C8.15512 51.9261 8.24679 52 8.35425 52H43.4223C43.5267 52 43.6178 51.9237 43.6387 51.8214C45.8708 40.8974 36.8592 35.9292 31.9048 34.7613C31.8126 34.7395 31.7466 34.6632 31.7363 34.569L30.557 23.7404C30.5447 23.6281 30.4499 23.543 30.3368 23.543H22.9755C22.8658 23.543 22.7726 23.6233 22.7565 23.7319L21.1449 34.5827C21.132 34.67 21.0658 34.7419 20.9807 34.7652Z",
    fill: "#FFB951",
    stroke: "black",
    strokeWidth: 0.221455,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.504 35.0958C18.7326 35.2938 17.0223 36.2336 16.0891 36.7327C16.0169 36.7713 15.9722 36.8463 15.9722 36.9282V50.1033C15.9722 50.1358 15.9794 50.168 15.9932 50.1975L16.417 51.0987C16.4524 51.174 16.527 51.2231 16.6101 51.2258L36.4709 51.8817C36.596 51.8858 36.6996 51.7855 36.6996 51.6603V50.1527L37.4465 37.5776C37.4508 37.5057 37.4203 37.4364 37.3632 37.3925C36.5741 36.7861 34.793 35.6717 33.7494 35.2837C33.6104 35.232 33.4718 35.3414 33.4751 35.4896C33.541 38.5027 33.1338 40.0956 32.931 40.2681C32.3029 40.936 21.3739 41.0695 20.3689 40.2681C19.6063 39.6599 19.6123 36.8407 19.7221 35.2981C19.7313 35.1687 19.6297 35.0635 19.504 35.0958Z",
    fill: "#352E57"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.6117,
    cy: 21.0711,
    rx: 8.73866,
    ry: 11.2498,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9688 32.4297C17.7359 30.6761 17.229 24.1268 17.8797 21.0713C18.866 24.0205 21.9209 24.6249 23.325 24.5585C23.736 22.7252 25.688 22.3998 26.6127 22.4662C29.736 22.3865 31.5442 23.4293 32.0579 23.9607C33.9484 22.2868 35.0374 22.0012 35.3456 22.0676C35.4484 23.8611 34.01 34.6216 24.9688 32.4297Z",
    fill: "#393157",
    stroke: "#393157",
    strokeWidth: 0.200889
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6049 24.004C30.8549 24.3255 29.8102 26.5486 29.0067 27.62C28.404 28.0218 28.1027 28.0218 27.2991 27.4191C26.4956 26.8165 26.2947 27.1178 25.2902 27.62C24.2858 28.1223 23.1809 27.4191 23.5827 25.3098C23.9845 23.2005 25.7925 23.6023 28.6049 24.004Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.200889
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2367 15.871C24.2495 15.9018 24.2468 15.9547 24.1801 16.0428C24.1154 16.1284 24.0065 16.2243 23.8644 16.3242C23.5817 16.523 23.1916 16.7212 22.8372 16.8695C22.489 17.0151 22.1515 17.0811 21.8896 17.0735C21.6175 17.0657 21.4689 16.9822 21.4257 16.879C21.4128 16.8481 21.4155 16.7953 21.4822 16.7071C21.5469 16.6216 21.6559 16.5257 21.7979 16.4257C22.0806 16.227 22.4707 16.0288 22.8252 15.8805C23.1733 15.7348 23.5109 15.6689 23.7728 15.6764C24.0448 15.6843 24.1935 15.7678 24.2367 15.871Z",
    fill: "#393157",
    stroke: "black",
    strokeWidth: 0.200889
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3883 17.3535C31.3648 17.3943 31.3224 17.4228 31.2442 17.4318C31.1631 17.4412 31.0541 17.4277 30.9207 17.3903C30.6548 17.316 30.3233 17.1567 29.9895 16.9639C29.6549 16.7707 29.3972 16.5897 29.2452 16.4247C29.1694 16.3424 29.1257 16.2702 29.1081 16.2084C29.0916 16.1504 29.0971 16.099 29.1267 16.0477C29.1826 15.9508 29.3407 15.8868 29.6115 15.9136C29.8723 15.9394 30.1987 16.0477 30.5255 16.2364C30.8524 16.4251 31.1093 16.6536 31.262 16.8666C31.4206 17.0877 31.4443 17.2566 31.3883 17.3535Z",
    fill: "#393157",
    stroke: "black",
    strokeWidth: 0.200889
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5987,
    cy: 17.7564,
    r: 0.301333,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.6253,
    cy: 18.3589,
    r: 0.301333,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2104 26.0934C26.7127 26.1938 28.2193 26.0934 28.6211 24.7876",
    stroke: "black",
    strokeWidth: 0.200889,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6385 18.6606C25.4376 19.3303 25.3171 20.7901 26.4421 21.2722",
    stroke: "black",
    strokeWidth: 0.200889,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.0875,
    cy: 20.4686,
    r: 0.803555,
    fill: "#D5CBDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.648 10.548C17.4951 12.0356 17.2718 15.6071 17.9483 17.7431C18.0108 17.9405 18.2905 17.8976 18.3327 17.6948C18.7954 15.4705 20.601 13.9827 21.6322 13.4217C21.7079 13.3806 21.8022 13.3978 21.8639 13.4579C27.4577 18.9073 32.637 17.276 34.5496 15.7602C34.5575 15.754 34.5647 15.7473 34.5714 15.7399C38.3288 11.681 36.8269 7.42569 35.5883 5.77647C35.5753 5.75904 35.5588 5.74399 35.5407 5.73185C32.6445 3.78789 32.4452 6.27348 32.7466 6.79264C33.049 7.31348 33.4522 9.50102 32.7466 9.50102C32.2045 9.50102 31.9909 8.60419 31.945 8.10257C31.9415 8.06339 31.9267 8.02489 31.9025 7.99388C30.7484 6.51583 30.0612 7.14344 29.8409 7.68476C29.8288 7.71445 29.8255 7.74635 29.8294 7.77818C29.9559 8.8231 29.8844 10.4574 28.6138 8.9802C27.3406 7.50001 26.4208 8.33245 26.1061 8.95527C26.0977 8.97193 26.0875 8.98729 26.0749 9.00111C25.1118 10.0602 23.4286 10.4671 22.6846 10.541C22.6722 10.5422 22.66 10.5446 22.648 10.548Z",
    fill: "#332C57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0744 18.0581C16.9695 17.4554 15.4628 18.5402 17.8735 20.8705M17.07 18.7612H17.8735",
    stroke: "black",
    strokeWidth: 0.200889,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 50,
    height: 48,
    rx: 21.1277,
    stroke: "url(#paint0_linear_823_7682)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_823_7682",
    x: 0.484211,
    y: 0.484211,
    width: 52.0316,
    height: 50.0316,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.257895
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.556863 0 0 0 0 0.329412 0 0 0 0 0.913725 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_823_7682"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_823_7682",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_823_7682",
    x1: 30.9243,
    y1: 50,
    x2: 16.8081,
    y2: 8.95154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F4981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76727C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_823_7682"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 51,
    height: 49,
    rx: 21.6277,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile_icon.4cef46a2e42c842a4477b3e6e65b117a.svg";
export { ForwardRef as ReactComponent };